// extracted by mini-css-extract-plugin
export var alignToRight = "Share-module--alignToRight--qGJ00";
export var root = "Share-module--root--j5YsI";
export var shareIcon = "Share-module--shareIcon--BFYMv";
export var shareLink = "Share-module--shareLink--fZMa3";
export var shareText = "Share-module--shareText--myPju";